module.exports = __webpack_public_path__ + "6e0938c1b97613abe5c313a95f6b7bed.svg";